module.exports = "https://cdn.thelire.com/ins/resource/icoUsernameGetstarte@3x.7d04d03d8a6b700eaee2573df2ca06b8.png";